module.exports = __webpack_public_path__ + "static/grizzlyBear-f5380a129a877934ca6182495096fd2b.jpg";